import { spacing } from '../../../../styles/spacing.css';
import { Flex } from '../../../Flex/Flex';
import { Icon } from '../../../Icon/Icon';
import * as styles from './CalendarHeader.css';

export interface NavigationButtonProps {
  readonly direction: 'back' | 'next';
  readonly isDisabled?: boolean;
  readonly onClick: () => void;
}

export const NavigationButton: React.FC<NavigationButtonProps> = ({ onClick, direction, isDisabled }) => {
  return (
    <Flex
      alignItems="center"
      aria-label={direction}
      as="button"
      className={styles.arrow}
      cursor="pointer"
      disabled={isDisabled}
      height={spacing.s40}
      justifyContent="center"
      onClick={onClick}
      type="button"
      width={spacing.s40}
    >
      <Icon name={direction} variant={isDisabled ? 'disabled' : 'primary'} />
    </Flex>
  );
};
